import type { ICreateAppRatingCmd } from "@/data/commands/feedback/CreateAppRatingCmd";
import type { IAppRating } from "@/data/model/Rating";
import type { IAppRatingsQry } from "@/data/queries/feedback/AppRatingsQry";
import { DateTime } from "@/data/util/DateTime";

import { BaseServiceDao, type IDataSource, type IPaginatedResult, parsePaginatedResult } from "./BaseServiceDao";

export class FeedbackDao extends BaseServiceDao implements IDataSource<IAppRating> {
    public static className = "FeedbackDao";

    constructor() {
        super("feedback");
    }

    public async getData(qry: IAppRatingsQry): Promise<IPaginatedResult<IAppRating>> {
        return this.get("", qry, (f) => parsePaginatedResult(f, FeedbackDao.parseAppRating));
    }

    public async rate(cmd: ICreateAppRatingCmd): Promise<IAppRating> {
        return this.post("", cmd, FeedbackDao.parseAppRating);
    }

    public async removeFeedback(id: string): Promise<void> {
        return this.delete(id);
    }

    public static parseAppRating(literal: any): IAppRating {
        return {
            id: literal.id,
            rating: parseInt(literal.rating),
            created: DateTime.parseIsoDate(literal.created),
            comment: literal.comment == null ? undefined : literal.comment,
            userName: literal.userName == null ? undefined : literal.userName,
            userId: literal.userId == null ? undefined : literal.userId,
        };
    }
}
